<template>
    <section class="check-balance-section pa-0">
        <v-container class="top-content px-0 pb-0">
            <v-row
                row
                class="check-balance-layout mx-0"
                :class="{
                    'justify-center': $vuetify.breakpoint.lgAndDown,
                    'align-center': $vuetify.breakpoint.xlOnly,
                }"
            >
                <v-col class="d-none d-xl-flex pa-0 col-xl-6"
                    ><page-heading></page-heading
                ></v-col>
                <v-col class="pa-0 col-xl-4">
                    <page-heading class="d-block d-xl-none"></page-heading>
                    <check-balance class="card-wrapper"></check-balance>
                    <div class="pin-info-wrapper d-md-none">
                        <pin-info class="pin-info page-content"></pin-info>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import pageHeading from '@/components/card/Balance/page-heading';
import checkBalance from '@/components/card/check-balance';
import pinInfo from '@/components/card/state/enter-pin/pin-info';
export default {
    name: 'card-balance',
    components: {
        pageHeading,
        checkBalance,
        pinInfo,
    },
    metaInfo() {
        return {
            titleTemplate: `%s | Check Balance`,
        };
    },
};
</script>
<style lang="scss" scoped>
.check-balance-section {
    position: relative;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-image: url('../../assets/connect-bg.jpg');
    .pin-info-wrapper {
        width: 100%;
        .pin-info {
            margin: 47px auto 0 auto;
        }
    }
    .card-wrapper {
        margin: 0 auto;
        @include break('md') {
            margin-bottom: 137px;
        }
        @include break('xl') {
            margin-top: 20px;
            margin-bottom: 0;
        }
    }
    @include break('xl') {
        .check-balance-layout {
            height: 990px;
        }
    }
}
</style>
